export default "__VITE_ASSET__2J4JYKrs__"